class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this._mainDetailsToggle = this.querySelector('details');
    this._content = this._mainDetailsToggle?.querySelector('summary')?.nextElementSibling;
    this._abort = null;
  }

  connectedCallback() {
    if (!this._mainDetailsToggle || !this._content) return;

    this._abort = new AbortController();
    this._mainDetailsToggle.addEventListener('focusout', this._onFocusOut, { signal: this._abort.signal });
    this._mainDetailsToggle.addEventListener('toggle', this._onToggle, { signal: this._abort.signal });
  }

  disconnectedCallback() {
    this._abort?.abort();
  }

  _onFocusOut = () => {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 0);
  };

  _handleToggleAnimations() {
    if (!this._mainDetailsToggle || !this._content) return;

    const animations = this._content.getAnimations();
    if (this._mainDetailsToggle.hasAttribute('open')) animations.forEach((a) => a.play());
    else animations.forEach((a) => a.cancel());
  }

  _onToggle = () => {
    this._handleToggleAnimations();
  };

  close() {
    if (!this._mainDetailsToggle) return;
    this._mainDetailsToggle.removeAttribute('open');
    this._mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  open() {
    if (!this._mainDetailsToggle) return;
    this._mainDetailsToggle.setAttribute('open', '');
    this._mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  get contentEl() {
    return this._content;
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  #sectionHeader;
  #abortHover;
  #hoverMq;

  constructor() {
    super();
    this.#sectionHeader = document.querySelector('.section-header');
    this.#hoverMq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  }

  connectedCallback() {
    super.connectedCallback?.();

    this.#abortHover = new AbortController();

    this.addEventListener('mouseenter', this._onMouseEnter, { signal: this.#abortHover.signal });
    this.addEventListener('mouseleave', this._onMouseLeave, { signal: this.#abortHover.signal });

    this.addEventListener('focusout', this._onFocusOut, { signal: this.#abortHover.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#abortHover?.abort();
  }

  _shouldUseHover = () => this.#hoverMq?.matches === true;

  _closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close?.();
    });
  }

  _onMouseEnter = () => {
    if (!this._shouldUseHover()) return;
    this._closeOtherMenus();
    this.open();
  };

  _onMouseLeave = () => {
    if (!this._shouldUseHover()) return;
    if (this.matches(':focus-within')) return;
    this.close();
  };

  _onFocusOut = (e) => {
    if (!this._shouldUseHover()) return;
    if (this.contains(e.relatedTarget)) return;
    this.close();
  };

  _onToggle = () => {
    this._handleToggleAnimations();

    const isOpen = this.querySelector('details')?.open === true;

    if (this.#sectionHeader) {
      this.#sectionHeader.preventHide = isOpen;
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
    );
  };
}

customElements.define('header-menu', HeaderMenu);
